// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__RgpEJ","icon":"SortAdornment_icon__2uuRS","up":"SortAdornment_up__1TAE4","down":"SortAdornment_down__18BJ2","active":"SortAdornment_active__M46Yr"};